import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import AppSectionRowComponentVue from './AppSectionRowComponent.vue';
import AppSectionColComponentVue from './AppSectionColComponent.vue';

@Component({
  components: {
    'app-section-row': AppSectionRowComponentVue,
    'app-section-col': AppSectionColComponentVue
  }
})
export default class AppSectionComponent extends Vue {}
